/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'profilency_products': {
    width: 20,
    height: 20,
    viewBox: '0 0 20 20',
    data: '<path pid="0" d="M9.797 11.538L1.63 7.244v6.527l8.167 4.294v-6.527zM.646 6.291a.5.5 0 0 1 .249-.564l3.417-1.825a.509.509 0 0 1 .116-.083l2.027-1.065a.5.5 0 0 1 .048-.022L10.062.83a.5.5 0 0 1 .471 0L19.7 5.727a.5.5 0 0 1 .249.565c.01.04.015.081.015.125v7.656a.5.5 0 0 1-.267.442l-9.166 4.82a.495.495 0 0 1-.483-.01l-9.15-4.809a.5.5 0 0 1-.267-.443V6.416c0-.043.006-.085.016-.125zm1.318-.001l8.333 4.381 2.731-1.436-8.346-4.397L1.964 6.29zm5.794-3.095l8.37 4.41L18.63 6.29l-8.333-4.451-2.54 1.356zm-1.066.57l-.945.504 8.588 4.524a.5.5 0 0 1 .266.442v2.175l1.022-.546.005-2.392-8.936-4.708zm4.105 7.773v6.527l8.166-4.294V7.245l-2.335 1.228-.006 2.692a.5.5 0 0 1-.264.44l-2.02 1.08a.5.5 0 0 1-.737-.44v-2.182l-2.804 1.475z" _fill="#848484" fill-rule="nonzero"/>'
  }
})



// WEBPACK FOOTER //
// ./src/compiled-icons/profilency_products.js